export const QUERY_KEYS = {
  COMMS_EMAIL_PREVIEW: 'useEmailPreview',
  VOUCHER_LIST: 'useVoucherList',
  REPORT_MERCHANT_LIST: 'useReportsMerchantList',
  REPORT_MERCHANT_SEARCH: 'useReportsMerchantSearch',
} as const
